import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// События лендинга кредитных карт

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDIT_CARDS_LANDING;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export const eventShowCreditCardLanding = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ',
  eventLabel: 'Показ лендинга',
  eventValue: undefined,
});

export const eventOnSubmitLimitButton = (amount: string | number): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Кнопка показать | ${amount}`,
  eventValue: undefined,
});

export const eventOnSubmitCreditCardOffer = (bankName: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Кнопка Отправить заявку | ${bankName}`,
  eventValue: undefined,
});
